<template>
  <div>
    <div class="headerFiltle">
      <div class="headFileitem">
        <div class="BrandSel" @click.stop="showBrand($event)">
          <span style="margin-left:10px;">品牌:</span>
          <p>{{BrandSel}}</p>
          <i class="el-icon-arrow-down" style="margin-right:10px"></i>
        </div>
        <div class="BrandSel" @click="changeOther($event)">
          <el-date-picker
            v-model="endTime"
            type="month"
            placeholder="请选择月"
            :editable="false"
            :clearable="false"
            style="width:110px;"
            format="yyyy-MM"
            value-format="yyyyMM"
            :picker-options="pickerOptions"
            @change="changeMonth(endTime)"
          ></el-date-picker>
        </div>

        <div class="BrandSel" @click.stop="showBrand2($event)">
          <span style="margin-left:10px;">品类:</span>
          <p>{{CateGory2SelCn}}</p>
          <el-icon class="el-icon-arrow-down"></el-icon>
        </div>
        <div class="BrandSel" @click.stop="showBrand3($event)">
          <span style="margin-left:10px;">渠道:</span>
          <p>{{platFormSel}}</p>
          <el-icon class="el-icon-arrow-down"></el-icon>
        </div>
      </div>
      <div class="headerHistory" v-show="BrandFlag">
        <span class="history_tie" style="background: transparent;">选择品牌:</span>
        <span
          v-for="item in option1"
          :key="item.value"
          class="history_tie"
          :class="{history_Active:item.text==BrandSel}"
          @click.stop="changeValue(item.text)"
        >{{item.text}}</span>
      </div>
      <div class="headerHistory" v-show="BrandFlag2">
        <span class="history_tie" style="background: transparent;">选择品类:</span>
        <span
          v-for="item in option2"
          :key="item.value"
          class="history_tie"
          :class="{history_Active:item.value==CateGory2Sel}"
          @click.stop="changeValue2(item.value,item.text)"
        >{{item.category2Cn}}</span>
      </div>
      <div class="headerHistory" v-show="BrandFlag3">
        <span class="history_tie" style="background: transparent;">选择渠道:</span>
        <span
          v-for="item in option3"
          :key="item.value"
          class="history_tie"
          :class="{history_Active:item.text==platFormSel}"
          @click.stop="changeValue3(item.text)"
        >{{item.text}}</span>
      </div>
    </div>

    <div class="main">
      <Competitive :ChangeFlag="MtYFlag" @chinaName="getChinaName" :SelCat2China="CateGory2SelCn"></Competitive>
      <div class="conTit" style="margin:10px 0">
        <span></span>
        <p>{{CateGory3SelCn}} 消费者偏好</p>
      </div>
      <div class="ConsumerPer">
        <span
          v-for="(item,i) in ConsumerPerTable"
          :key="item.value"
          :class="{ConsumerPer_act:i==actVal}"
          :attr="item.attr"
          @click="changeConsumerPer(item.value,$event)"
        >{{item.name}}</span>
      </div>
      <div class="Consumer_table">
        <div class="Consumer_table_Tie" @click="changeFlag()">
          <span :class="{table_TieAct:MtYFlag}">年度</span>
          <span :class="{table_TieAct:!MtYFlag}">月度</span>
        </div>
        <div>
          <div id="TopSku" class="Consumer_table_none">
            <div class="Consumer_table_Tie" @click="changeFlagGMV()">
              <span :class="{table_TieAct:GmvFlag}">飙升</span>
              <span :class="{table_TieAct:!GmvFlag}">销量</span>
            </div>
            <div class="tableHead">
              <van-row>
                <van-col span="3">
                  <div style="opacity: 0;">1</div>
                </van-col>
                <van-col span="11">渠道</van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV.png" alt style="width:13px;height:13px" />市场GMV
                </van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV同比.png" alt style="width:13px;height:13px" />市场同比
                  <i class="el-icon-top"></i>
                </van-col>
              </van-row>
            </div>
            <div class="tableBody">
              <van-row v-for="(item,i) in TopSkuList1" :key="i">
                <van-col span="3" :class="i<1?'table_top':i>=2?' table_bot':' table_mid'">
                  <span style="position: relative;">
                    No.
                    <br />
                    <i style="position: absolute;top:12px;left:5px;font-size:10px">{{item.rank}}</i>
                  </span>
                </van-col>
                <van-col
                  span="11"
                  style="white-space: initial;line-height:25px;margin-bottom: 10px"
                >{{item.skuName}}</van-col>
                <van-col span="5">{{item.salesEn}}</van-col>
                <van-col span="5">{{item.growth}}</van-col>
                <div style="width:90%;height:0.5px;background: #CDCDD1;padding-left:20%"></div>
              </van-row>
            </div>
          </div>
          <div id="PricebandMain">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="24">
                    <div class="grid-content bg-purple">
                      <div id="PriceBand"></div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <div class="grid-content bg-purple">
                        <template>
                          <el-table
                            :data="tableDataJnJ"
                            :header-cell-style="{background:'#FAF1E7',color:'#555555'}"
                            :row-style="{background:'#FAF1E7',color:'#555555'}"
                          >
                            <el-table-column prop="name" label="渠道" align="center" width="70px"></el-table-column>
                            <el-table-column prop="oraginal" label="区间" align="center" width="60px"></el-table-column>
                            <el-table-column
                              prop="growth"
                              label="GMV增长"
                              align="center"
                              width="70px"
                            ></el-table-column>
                          </el-table>
                        </template>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-row>
                  <el-col :span="24">
                    <div class="grid-content bg-purple">
                      <div id="MarketPriceBand"></div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <div class="grid-content bg-purple">
                        <template>
                          <el-table
                            :data="tableDataMarket"
                            :header-cell-style="{background:'#FAF1E7',color:'#555555'}"
                            :row-style="{background:'#FAF1E7',color:'#555555'}"
                          >
                            <el-table-column prop="name" label="渠道" align="center" width="70px"></el-table-column>
                            <el-table-column prop="oraginal" label="区间" align="center" width="60px"></el-table-column>
                            <el-table-column
                              prop="growth"
                              label="GMV增长"
                              align="center"
                              width="70px"
                            ></el-table-column>
                          </el-table>
                        </template>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div id="Component" class="Consumer_table_none">
            <div class="Consumer_table_Tie" @click="changeFlagGMV()">
              <span :class="{table_TieAct:GmvFlag}">飙升</span>
              <span :class="{table_TieAct:!GmvFlag}">销量</span>
            </div>
            <div class="tableHead" style="margin-top:10px">
              <p class="compomentMsg">*现仅包含美妆系列33种火热成分，且仅随时间过滤器变化</p>
              <van-row>
                <van-col span="3">
                  <div style="opacity: 0;">1</div>
                </van-col>
                <van-col span="11">渠道</van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV.png" alt style="width:13px;height:13px" />市场GMV
                </van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV同比.png" alt style="width:13px;height:13px" />市场同比
                  <i class="el-icon-top"></i>
                </van-col>
              </van-row>
            </div>
            <div class="tableBody">
              <van-row v-for="(item,i) in CompomentList1" :key="i">
                <van-col span="3" :class="i<1?'table_top':i>=2?' table_bot':' table_mid'">
                  <span style="position: relative;">
                    No.
                    <br />
                    <i style="position: absolute;top:12px;left:5px;font-size:10px">{{i+1}}</i>
                  </span>
                </van-col>
                <van-col span="11">{{item.ingredient}}</van-col>
                <van-col span="5">{{item.salesEn}}</van-col>
                <van-col span="5">{{item.growth}}</van-col>
                <div style="width:90%;height:0.5px;background: #CDCDD1;padding-left:20%"></div>
              </van-row>
            </div>
          </div>
          <div id="Degree" class="Consumer_table_none">
            <div class="Consumer_table_Tie" @click="changeFlagGMV()">
              <span :class="{table_TieAct:GmvFlag}">飙升</span>
              <span :class="{table_TieAct:!GmvFlag}">销量</span>
            </div>
            <p class="compomentMsg1">*现仅有大宝与露得清拥有搜索词数据，其他品牌接下来会陆续更新</p>

            <div style="margin:10px 15px ;width:100%;display:flex">
              <div class="listSel MylistSel">
                <p>二级品类:</p>
                <van-dropdown-menu active-color="#CC4545" :overlay="false">
                  <van-dropdown-item
                    v-model="Degree"
                    :options="DegreeList"
                    @change="changeDegree(Degree)"
                  />
                </van-dropdown-menu>
              </div>
              <div class="listSel2 MylistSel2">
                <p>三级品类:</p>
                <van-dropdown-menu active-color="#CC4545" :overlay="false">
                  <van-dropdown-item
                    v-model="Degree1"
                    :options="DegreeList1"
                    @change="changeDegree1(Degree1)"
                    class="right"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="tableHead">
              <van-row>
                <van-col span="4">
                  <div style="opacity: 0;">1</div>
                </van-col>
                <van-col span="12">搜索热词</van-col>
                <van-col span="4">搜索人数</van-col>
                <van-col span="4">
                  <div style="opacity: 0;">1</div>
                </van-col>
              </van-row>
            </div>
            <div class="tableBody">
              <van-row v-for="(item,i) in DegreetableData" :key="i">
                <van-col
                  span="4"
                  :class="i<1?'table_top':i>=2?' table_bot':' table_mid'"
                >No.{{item.ranking}}</van-col>
                <van-col span="12" style="text-align:center">{{item.keyword}}</van-col>
                <van-col span="4">{{item.searchesEn}}</van-col>
                <van-col span="4">
                  <div style="opacity: 0;">1</div>
                </van-col>
              </van-row>
            </div>
          </div>
          <div id="HotWords" class="Consumer_table_none">
            <div class="tableHead" style="margin-top:10px">
              <!-- <p class="compomentMsg">*现仅包含美妆系列33种火热成分，且仅随时间过滤器变化</p> -->
              <van-row>
                <van-col span="3">
                  <div style="opacity: 0;">1</div>
                </van-col>
                <van-col span="11">渠道</van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV.png" alt style="width:13px;height:13px" />市场GMV
                </van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV同比.png" alt style="width:13px;height:13px" />市场同比
                  <i class="el-icon-top"></i>
                </van-col>
              </van-row>
            </div>
            <div class="tableBody">
              <van-row v-for="(item,i) in HotWordsList" :key="i">
                <van-col span="3" :class="i<1?'table_top':i>=2?' table_bot':' table_mid'">
                  <span style="position: relative;">
                    No.
                    <br />
                    <i style="position: absolute;top:12px;left:5px;font-size:10px">{{i+1}}</i>
                  </span>
                </van-col>
                <van-col span="11">{{item.keyword}}</van-col>
                <van-col span="5">{{item.salesEn}}</van-col>
                <van-col span="5">{{item.growth}}</van-col>
                <div style="width:90%;height:0.5px;background: #CDCDD1;padding-left:20%"></div>
              </van-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import Competitive from "@/components/ButFo_Radar/public/Competitive_Overview";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 - 2592000000 - 2592000000;
        },
      },
      GmvFlag: true,
      BrandSel: "",
      CateGory2Sel: "",
      CateGory3Sel: "",
      CateGory2SelCn: "",
      CateGory3SelCn: "",
      Degree1: "",
      Degree: "",
      DegreeList1: [],
      DegreeList: [],
      DegreetableData: [],
      platFormSel: "",
      option1: [],
      option2: [],
      option3: [],
      tableData1: [],
      tableDataJnJ: [],
      tableDataMarket: [],
      BrandList: [],
      BrandList2: [],
      BrandList3: [],
      MtYFlag: true,
      BrandFlag: false,
      BrandFlag2: false,
      BrandFlag3: false,
      startTime: "",
      endTime: "",
      priceTie: [],
      priceTieData: [],
      priceTie1: [],
      priceTieData1: [],
      TopSkuList1: [],
      CompomentList1: [],
      HotWordsList: [],
      ConsumerPerTable: [
        { name: "Top Sku", value: 0, attr: "Top Sku" },
        { name: "价格带", value: 1, attr: "价格带" },
        { name: "成分", value: 2, attr: "成分" },
        { name: "搜索词", value: 3, attr: "搜索词" },
        { name: "标题热词", value: 4, attr: "标题热词" },
      ],
      actVal: 1,
    };
  },
  methods: {
    getChinaName(data) {
      this.CateGory3SelCn = data;
    },
    changeConsumerPer(actVal, e) {
      this.actVal = actVal;
      if ($(e.currentTarget).attr("attr") == "Top Sku") {
        $("#TopSku").css("display", "block");
        $("#TopSku").siblings().css("display", "none");
      } else if ($(e.currentTarget).attr("attr") == "价格带") {
        $("#PricebandMain").css("display", "block");
        $("#PricebandMain").siblings().css("display", "none");
      } else if ($(e.currentTarget).attr("attr") == "成分") {
        $("#Component").css("display", "block");
        $("#Component").siblings().css("display", "none");
      } else if ($(e.currentTarget).attr("attr") == "搜索词") {
        $("#Degree").css("display", "block");
        $("#Degree").siblings().css("display", "none");
      } else {
        $("#HotWords").css("display", "block");
        $("#HotWords").siblings().css("display", "none");
      }
    },
    MarketBrand() {
      var option = {
        title: {
          show: true,

          text: "  J&J价格带 Low —> High",
          subtext: "",
          textStyle: {
            color: "#909399",
            fontSize: 10,
            lineHeight: 28,
          },
          subtextStyle: {
            color: "black",
            fontSize: 10,
            lineHeight: 28,
          },
        },
        tooltip: {
          position: ["10%", "50%"],
          show: true,
          trigger: "item",
          formatter: "{a0} : {c0}%",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: this.priceTie,
          show: false,
          itemWidth: 10,
          itemHeight: 10,
          right: 0,
          top: "5%",
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },
        xAxis: {
          show: false,
          type: "value",
          max: 100,
        },
        yAxis: {
          show: false,
          type: "category",
        },
        series: this.priceTieData,
      };
      let PriceBand = this.$echarts.init(document.getElementById("PriceBand"));
      PriceBand.setOption(option);
    },
    PriceBand() {
      var option = {
        title: {
          show: true,
          text: "  市场价格带 Low —> High",
          textStyle: {
            color: "#909399",
            fontSize: 10,
            lineHeight: 28,
          },
        },
        tooltip: {
          position: ["50%", "50%"],
          show: true,
          trigger: "item",
          formatter: "{a0} : {c0}% </br>",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: this.priceTie1,
          show: false,
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20,
          right: 0,
          top: "23%",
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },

        xAxis: {
          show: false,
          type: "value",
          max: 100,
        },
        yAxis: {
          show: false,
          type: "category",
        },
        series: this.priceTieData1,
      };
      let MarketPriceBand = this.$echarts.init(
        document.getElementById("MarketPriceBand")
      );
      MarketPriceBand.setOption(option);
    },
    getBrand() {
      this.$addr
        .post("/radar/getBrand", qs.stringify({ platForm: "", cateGory: "" }))
        .then((res) => {
          this.BrandList = res.data.data;
          this.option1 = [];
          this.BrandList.map((item, index) => {
            this.option1.push(
              Object.assign({}, item, {
                text: item.brandNameEn,
                value: item.brandNameEn,
              })
            );
          });
          this.BrandSel = this.BrandList[2].brandNameEn;
          this.$store.dispatch("getComBrand", this.BrandSel);
          this.getBrand2();
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    getBrand2() {
      this.$addr
        .post(
          "/radar/getCateGory2",
          qs.stringify({ platForm: "", brand: this.BrandSel })
        )
        .then((res) => {
          this.BrandList2 = res.data.data;
          this.option2 = [];
          this.BrandList2.map((item, index) => {
            this.option2.push(
              Object.assign({}, item, {
                text: item.category2Cn,
                value: item.category2,
              })
            );
          });
          this.CateGory2Sel = this.BrandList2[0].category2;
          this.CateGory2SelCn = this.BrandList2[0].category2Cn;
          this.$store.dispatch("getComCateGory2", this.CateGory2Sel);
          this.getBrand3();
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    getBrand3() {
      this.$addr
        .post(
          "/radar/getPlatForm",
          qs.stringify({ cateGory2: this.CateGory2Sel, brand: this.BrandSel })
        )
        .then((res) => {
          this.BrandList3 = res.data.data;
          this.option3 = [];
          this.BrandList3.map((item, index) => {
            this.option3.push(
              Object.assign({}, item, {
                text: item.platform,
                value: item.platform,
              })
            );
          });
          this.platFormSel = this.BrandList3[0].platform;
          this.$store.dispatch("getPlatForm", this.platFormSel);
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    getMonth() {
      this.$addr
        .post("/radar/getUpdateDate")
        .then((res) => {
          if (this.MtYFlag) {
            this.startTime = res.data.data[0].startDate;
          } else {
            this.startTime = res.data.data[0].yyyymm;
          }
          this.endTime = res.data.data[0].yyyymm;
          this.$store.dispatch("getComMonthFrom", this.startTime);
          this.$store.dispatch("getComMonthTo", this.endTime);
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    changeMonth(data) {
      if (this.MtYFlag) {
        this.startTime = data.slice(0, 4) + "01";
        this.endTime = data;
        this.$store.dispatch("getComMonthFrom", data.slice(0, 4) + "01");
        this.$store.dispatch("getComMonthTo", data);
      } else {
        this.startTime = data;
        this.endTime = data;
        this.$store.dispatch("getComMonthFrom", data);
        this.$store.dispatch("getComMonthTo", data);
      }
    },
    changeOther(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      this.BrandFlag = false;
      this.BrandFlag2 = false;
      this.BrandFlag3 = false;
    },
    changeFlag() {
      this.getMonth();
      this.getPriceTier();
      this.MtYFlag = !this.MtYFlag;
      this.$store.dispatch("getComFlag", this.MtYFlag);
    },
    changeFlagGMV() {
      this.GmvFlag = !this.GmvFlag;
      this.setTwoGet();
      this.setThrGet();
      this.setForGet();
      this.setFivGet();
    },
    showBrand(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      $(e.currentTarget).siblings(".BrandSel").removeClass("industry_footAct");
      this.BrandFlag = !this.BrandFlag;
      this.BrandFlag2 = false;
      this.BrandFlag3 = false;
    },
    showBrand2(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      $(e.currentTarget).siblings(".BrandSel").removeClass("industry_footAct");
      this.BrandFlag2 = !this.BrandFlag2;
      this.BrandFlag = false;
      this.BrandFlag3 = false;
    },
    showBrand3(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      $(e.currentTarget).siblings(".BrandSel").removeClass("industry_footAct");
      this.BrandFlag3 = !this.BrandFlag3;
      this.BrandFlag = false;
      this.BrandFlag2 = false;
    },
    changeValue(text) {
      this.BrandSel = text;
      this.getBrand2();
      this.$store.dispatch("getComBrand", this.BrandSel);
      this.BrandFlag = false;
    },
    changeValue2(value, text) {
      this.CateGory2Sel = value;
      this.CateGory2SelCn = text;
      this.getBrand3();
      this.$store.dispatch("getComCateGory2", this.CateGory2Sel);
      this.BrandFlag2 = false;
    },
    changeValue3(text) {
      this.platFormSel = text;
      this.$store.dispatch("getPlatForm", this.platFormSel);
      this.BrandFlag2 = false;
    },
    getPriceTier() {
      this.$addr
        .post(
          "/radar/getPriceTier",
          qs.stringify({
            platForm: this.platFormSel,
            cateGory1: "",
            cateGory2: this.CateGory2Sel,
            cateGory3: this.CateGory3Sel,
            monthFrom: this.startTime,
            monthTo: this.endTime,
            brand: this.BrandSel,
          })
        )
        .then((res) => {
          this.CateGory1List = res.data.data;
          this.tableDataJnJ = [];
          this.tableDataMarket = [];
          this.priceTie1 = [];
          this.priceTieData1 = [];
          this.priceTie = [];
          this.priceTieData = [];
          this.CateGory1List.map((item, index) => {
            if (item.jnj == true) {
              this.tableDataJnJ.push({
                growth: item.growth,
                name: item.priceTier,
                oraginal: item.oraginal,
              });
              this.priceTie.push(item.priceTier);
              this.priceTieData.push({
                name: item.priceTier,
                barWidth: 20,
                type: "bar",
                stack: "总量",
                label: {
                  show: false,
                  position: "insideRight",
                },
                data: [parseFloat(item.share)],
              });
            } else if (item.jnj == false) {
              this.priceTie1.push(item.priceTier);
              this.tableDataMarket.push({
                growth: item.growth,
                name: item.priceTier,
                oraginal: item.oraginal,
              });
              this.priceTieData1.push({
                name: item.priceTier,
                barWidth: 20,
                type: "bar",
                stack: "总量",
                label: {
                  show: false,
                  position: "insideRight",
                },
                data: [parseFloat(item.share)],
              });
            }
          });
          this.priceTieData1.reverse();
          this.priceTieData.reverse();
          this.MarketBrand();
          this.PriceBand();
        })
        .catch((error) => {
          this.$toast("接受数据中……");
        });
    },
    getTopSku() {
      if (this.GmvFlag) {
        this.$addr
          .post(
            "/radar/getTopSku",
            qs.stringify({
              platForm: this.platFormSel,
              cateGory1: "",
              cateGory2: this.CateGory2Sel,
              cateGory3: this.CateGory3Sel,
              monthFrom: this.startTime,
              monthTo: this.endTime,
              brand: this.BrandSel,
              GMV: 0,
            })
          )
          .then((res) => {
            this.TopSkuList1 = [];
            this.TopSkuList1 = res.data.data;
          });
      } else {
        this.$addr
          .post(
            "/radar/getTopSku",
            qs.stringify({
              platForm: this.platFormSel,
              cateGory1: "",
              cateGory2: this.CateGory2Sel,
              cateGory3: this.CateGory3Sel,
              monthFrom: this.startTime,
              monthTo: this.endTime,
              brand: this.BrandSel,
              GMV: 1,
            })
          )
          .then((res) => {
            this.TopSkuList1 = [];
            this.TopSkuList1 = res.data.data;
          });
      }
    },
    getCompon() {
      if (this.GmvFlag) {
        this.$addr
          .post(
            "/radar/getTopIngredient",
            qs.stringify({
              monthFrom: this.startTime,
              monthTo: this.endTime,
              GMV: 0,
            })
          )
          .then((res) => {
            this.CompomentList1 = [];
            this.CompomentList1 = res.data.data;
          });
      } else {
        this.$addr
          .post(
            "/radar/getTopIngredient",
            qs.stringify({
              monthFrom: this.startTime,
              monthTo: this.endTime,
              GMV: 1,
            })
          )
          .then((res) => {
            this.CompomentList1 = [];
            this.CompomentList1 = res.data.data;
          });
      }
    },
    getDegreeList1() {
      this.$addr
        .post(
          "/radar/getSearchCategory",
          qs.stringify({
            monthFrom: this.startTime,
            monthTo: "202007",
            brand: this.BrandSel,
            firstCategory: "",
            secondCategory: this.Degree,
            thirdCategory: "",
          })
        )
        .then((res) => {
          this.DegreeList1 = [];
          res.data.data.map((item) => {
            this.DegreeList1.push({
              text: item.thirdCategory,
              value: item.thirdCategory == "" ? "1" : item.thirdCategory,
            });
            this.Degree1 = item.thirdCategory;
          });
          this.getDegreeListRank();
        });
    },
    getDegreeList() {
      this.$addr
        .post(
          "/radar/getSearchCategory",
          qs.stringify({
            monthFrom: this.startTime,
            monthTo: "202007",
            brand: this.BrandSel,
            firstCategory: "",
            secondCategory: "",
            thirdCategory: "",
          })
        )
        .then((res) => {
          this.DegreeList = [];
          res.data.data.map((item) => {
            this.DegreeList.push({
              text: item.secondCategory,
              value: item.secondCategory == "" ? "1" : item.secondCategory,
            });
            this.Degree = item.secondCategory;
          });
          this.getDegreeList1();
        });
    },
    getDegreeListRank() {
      if (this.GmvFlag) {
        this.$addr
          .post(
            "/radar/getTopSearchRanking",
            qs.stringify({
              monthFrom: this.startTime,
              monthTo: "202007",
              brand: this.BrandSel,
              firstCategory: "",
              secondCategory: this.Degree,
              thirdCategory: this.Degree1,
              GMV: "0",
            })
          )
          .then((res) => {
            this.DegreetableData = res.data.data;
          });
      } else {
        this.$addr
          .post(
            "/radar/getTopSearchRanking",
            qs.stringify({
              monthFrom: this.startTime,
              monthTo: "202007",
              brand: this.BrandSel,
              firstCategory: "",
              secondCategory: this.Degree,
              thirdCategory: this.Degree1,
              GMV: "1",
            })
          )
          .then((res) => {
            this.DegreetableData = res.data.data;
          });
      }
    },
    changeDegree(value) {
      if (value == "") {
        this.Degree = "1";
        this.Degree1 = "1";
      }
      this.getDegreeList1();
    },
    changeDegree1(value) {
      if (value == "") {
        this.Degree1 = "1";
      }
      this.getDegreeListRank();
    },
    getHotWords() {
      if (this.GmvFlag) {
        this.$addr
          .post(
            "/radar/getTopTableHotSearch",
            qs.stringify({
              monthFrom: this.startTime,
              monthTo: this.endTime,
              brand: this.BrandSel,
              platForm: this.platFormSel,
              cateGory2: this.CateGory2Sel,
              cateGory3: this.CateGory3Sel,
              GMV: "0",
            })
          )
          .then((res) => {
            this.HotWordsList = res.data.data;
          });
      } else {
        this.$addr
          .post(
            "/radar/getTopTableHotSearch",
            qs.stringify({
              monthFrom: this.startTime,
              monthTo: this.endTime,
              brand: this.BrandSel,
              platForm: this.platFormSel,
              cateGory2: this.CateGory2Sel,
              cateGory3: this.CateGory3Sel,
              GMV: "1",
            })
          )
          .then((res) => {
            this.HotWordsList = res.data.data;
          });
      }
    },
  },
  components: {
    Competitive,
  },
  created() {
    this.getBrand();
    this.getMonth();
    let _ = require("lodash");
    this.setOneGet = _.debounce(this.getPriceTier, 500);
    this.setTwoGet = _.debounce(this.getTopSku, 500);
    this.setThrGet = _.debounce(this.getCompon, 500);
    this.setForGet = _.debounce(this.getDegreeList, 500);
    this.setFivGet = _.debounce(this.getHotWords, 500);
  },
  computed: {
    ...mapState([
      "ComMonthFrom",
      "ComMonthTo",
      "ComBrand",
      "ComCateGory2",
      "ComCateGory3",
      "PlatForm",
      "ComMyFlag",
    ]),
  },
  watch: {
    ComCateGory3(currVal) {
      console.log(currVal);
      this.CateGory3Sel = currVal;
      this.setOneGet();
      this.setTwoGet();
      this.setForGet();
      this.setFivGet();
    },
    ComMonthFrom(currVal) {
      this.setThrGet();
      this.setForGet();
      this.setFivGet();
    },
    ComMonthTo(currVal) {
      this.setThrGet();
      this.setForGet();
      this.setFivGet();
    },
    ComBrand(currVal) {
      this.setForGet();
      this.setFivGet();
    },
    ComCateGory2(currVal) {
      this.setFivGet();
    },
  },
};
</script>
<style scoped>
.disb {
  background-color: #ccc !important;
}
#PriceBand {
  width: 100%;
  min-height: 100px;
}
#MarketPriceBand {
  width: 100%;
  min-height: 100px;
}
.Consumer_table {
  position: relative;
  padding: 40px 0px 10px;
  min-height: 250px;
  margin-bottom: 20px;
  box-shadow: 0 10px 30px 0 rgba(178, 180, 190, 0.5);
  border-radius: 25px;
  background: #faf1e7;
}
.industry_footAct {
  position: relative;
  background-color: #f6e7d4 !important;
  border: 3px solid #d9b17e !important;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
}
.Consumer_table_none {
  display: none;
}
.Consumer_table_Tie {
  width: 180px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 0px;
  margin-left: -90px; /* 宽度的一半 */
  background: #f3e7da;
  border-radius: 0px 0px 15px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}
.Consumer_table_Tie span {
  height: 30px;
  line-height: 30px;
  width: 50%;
  font-family: "SourceHanSansCN-ExtraLight";
  font-size: 14px;
  color: #b4926c;
  letter-spacing: 0;
  text-align: center;
}
.table_TieAct {
  background: #f6e7d4;
  box-shadow: 0 2px 10px -5px #633e0f;
  border-radius: 0 0 15px 15px;
  border-radius: 0px 0px 15px 15px;
}
.ConsumerPer {
  display: flex;
  align-items: center;
  height: 80px;
  overflow-x: scroll;
}
.ConsumerPer_act {
  background: #f6e7d4;
  border: 3px solid #d9b17e;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
  border-radius: 34px;
}
.ConsumerPer span {
  height: 40px;
  min-width: 80px;
  line-height: 40px;
  text-align: center;
  margin: 0 5px;
  box-shadow: 0 3px 8px 0 rgba(231, 231, 249, 0.8);
  background: #faf1e7;
  border-radius: 34px;
  font-family: "PingFangSC-Regular";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
}
.industry span {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.main {
  padding: 10px;
  margin-top: 80px;
}
.headerFiltle {
  background: #faf1e7;
  padding: 20px 0;
  margin-bottom: 10px;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.headFileitem {
  width: 100%;
  height: 48px;
  overflow: scroll;
  display: flex;
}
/deep/.el-input__inner {
  background: rgb(89, 91, 102) !important;
}
.headerHistory {
  position: relative;
  height: 66px;
  background-color: #fff;
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  top: 15px;
}

.headerHistory span {
  margin: auto 10px;
  font-family: "SourceHanSansCN-Bold";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
}

.history_tie {
  padding: 0px 5px;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  min-width: 80px;
  text-align: center;
  overflow-y: scroll;
  background: #fff8f1;
  border-radius: 13px;
}
.history_Active {
  background: #f6e7d4;
}
.BrandSel {
  border: 1px solid #ccc;
  z-index: 5;
  background: #faf1e7;
  box-shadow: 0 3px 20px 0 rgba(192, 168, 139, 0.3);
  border-radius: 10px;
  min-width: 125px;
  height: 40px;
  display: flex;
  align-items: center;
  font-family: "SourceHanSansCN-Light";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
  line-height: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 10px;
}
/deep/ .el-input .el-input__inner {
  background: #faf1e7 !important;
}
.industry_echarts {
  padding: 10px;
  border-radius: 15px;
  min-height: 200px;
  margin-bottom: 20px;
  background: #faf1e7;
  box-shadow: 0 10px 30px 0 rgba(178, 180, 190, 0.5);
  border-radius: 20px;
}
#IndEcharts {
  width: 100%;
  min-height: 200px;
}
.conTit {
  margin-left: 8%;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #555555;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.conTitAb {
  width: 130px;
  position: absolute;
  right: 23px;
  line-height: 21px;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.conTitAb b {
  font-family: "SourceHanSansCN-ExtraLight";
  font-size: 14px;
  color: #484781;
  letter-spacing: 0;
  text-align: center;
  line-height: 29px;
}
.conTitAbAct {
  font-family: "SourceHanSansCN-Bold";
  color: #494949 !important;
  border-bottom: 2px solid #494949;
}

.tableHead {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #5d5d5d;
  letter-spacing: 0;
  position: relative;
}
.compomentMsg {
  position: absolute;
  top: -21px;
  left: 10px;
  font-size: 9px;
  color: #494949;
}
.compomentMsg1 {
  font-size: 9px;
  color: #494949;
}
.tableBody {
  text-align: center;
  line-height: 55px;
  border-bottom: 1px solid #ccc;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-y: hidden;
}
.table_top {
  background: #9a3231;
  color: #fff;
  border-radius: 0 5px 5px 0;
  height: 45px;
  line-height: 27px;
}
.table_mid {
  color: #fff;
  background: #ba4d4c;
  border-radius: 0 5px 5px 0;
  height: 45px;
  line-height: 27px;
}
.table_bot {
  color: #fff;
  background: #d58a89;
  border-radius: 0 5px 5px 0;
  height: 45px;
  line-height: 27px;
}
.listSel2,
.listSel {
  width: 40%;
  display: flex;
  align-items: center;
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  line-height: 14px;
}
.MylistSel {
  width: 50%;
}
.MylistSel2 {
  width: 50%;
}
.MylistSel2 .van-dropdown-menu {
  width: 50% !important;
}
.MylistSel .van-dropdown-menu {
  width: 50% !important;
}

.listSel2 .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 40%;
  height: 20px;
  position: relative;
  left: 10px;
}

.listSel .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 40%;
  height: 20px;
  position: relative;
  left: 10px;
}
.listSel .van-dropdown-menu /deep/ .van-popup--top {
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  width: 27%;
  left: 14.5% !important;
}

.listSel2 .van-dropdown-menu /deep/ .van-popup--top {
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  width: 27%;
  left: 69% !important;
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #555555;
}
/deep/ .van-dropdown-menu__title::after {
  text-align: right;
  border-color: transparent transparent #555555 #555555;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
/deep/ .van-dropdown-menu__bar{
  height: 100%;
  background:  none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/Competitive_Radar.vue